import React from 'react'
import { PRIMARY_COLOR, BACKGROUND_DARK2 } from '../../constants';
import { Icon } from 'semantic-ui-react';

const edgeWidth = 2;

class Diagram extends React.Component {
  
    render() {
    const activeNode = this.props.activeNode;
    const activeEdge = this.props.activeEdge;
    const currentTime = this.props.currentTime;
      return (
          <div>
              
          
        
        <svg viewBox="0 65 430 300" style={{width: '100%', maxWidth: '30em'}}>
            <defs>
                <linearGradient id="grad1" x1={(parseInt(currentTime*100, 10)-0.1)+"%"} y1="0%" x2={parseInt(currentTime*100, 10)+"%"} y2="0%">
                    <stop offset="0%" style={{stopColor: PRIMARY_COLOR, stopOpacity: 1}} />
                    <stop offset="100%" style={{stopColor: BACKGROUND_DARK2, stopOpacity: 1}} />
                </linearGradient>
            </defs>
            <path
                id="path4185-1"
                d="m 105.51758,237.05617 c 0,0 0.16336,15.01461 -4.48992,19.95947 -7.606099,6.89086 -20.723615,2.10734 -27.029428,7.67558 -4.167097,3.93155 -5.742162,16.27771 -5.742162,16.27771"
                stroke={3 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            <path
                id="path4185-9"
                d="m 222.45821,141.20364 c 0,0 1.60436,12.81031 14.52536,19.34502 12.921,6.53471 49.76087,1.91615 56.8316,5.52505 10.75312,5.48838 13.64886,18.12104 13.64886,18.12104"
                stroke={2 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            <path
                id="path4185"
                d="m 206.17747,140.76064 c 0,0 -1.60435,12.81031 -14.52536,19.34503 -12.92099,6.5347 -49.76086,1.91614 -56.83159,5.52503 -10.75311,5.4884 -13.64886,18.12106 -13.64886,18.12106"
                stroke={1 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            <path
                id="path4185-1-2"
                d="m 120.12182,236.89238 c 0,0 -0.16336,15.0146 4.48993,19.95946 7.60609,6.89086 30.75903,1.49291 37.06484,7.06115 4.1671,3.93155 5.74216,16.58493 5.74216,16.58493"
                stroke={4 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            <path
                id="path4185-1-7"
                d="m 136.54342,236.89238 c 0,0 5.02802,11.25343 13.02645,15.27662 7.60608,6.89087 90.3119,0.5395 103.68517,8.92629 7.19274,4.51081 8.71836,19.27538 8.71836,19.27538"
                stroke={5 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            {
                /*
<path
                id="path4185-1-0"
                d="m 298.29232,237.70457 c 0,0 -2.84718,12.84225 -7.50039,17.7871 -7.60609,6.89086 -16.42295,2.10734 -22.72876,7.67559 -4.16709,3.93154 -5.74215,17.58111 -5.74215,17.58111"
                stroke={6 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
                */
            }
            
            <path
                id="path4185-1-0-9"
                d="m 310.72983,237.83818 c 0,0 2.84719,12.84222 7.50039,17.78707 7.6061,6.89087 18.14323,3.84525 24.44904,9.4135 4.1671,3.93154 5.74216,17.58111 5.74216,17.58111"
                stroke={7 === activeEdge ? PRIMARY_COLOR : 'white'} strokeWidth={edgeWidth} fill="transparent" />
            
            
            
            



            <rect
                ry="16.181023"
                y="88.532173"
                x="175.92754"
                height="53.652874"
                width="77.63797"
                id="rect4136"
                onClick={() => 1 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={1 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />
            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 1 === activeNode && this.props.onToggleAudio()}
                        transform="translate(175.92754,88.532173) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={1 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 1 === activeNode && this.props.onToggleAudio()}
                        fill={1 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(175.92754,88.532173) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }
            
            <rect
                ry="16.181023"
                y="183.41922"
                x="82.591454"
                height="53.652874"
                width="77.63797"
                id="rect4136-3"
                onClick={() => 2 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={2 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 2 === activeNode && this.props.onToggleAudio()}
                        transform="translate(82.591454,183.41922) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={2 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 2 === activeNode && this.props.onToggleAudio()}
                        fill={2 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(82.591454,183.41922) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }

            <rect
                ry="16.181023"
                y="184.27083"
                x="267.16467"
                height="53.652874"
                width="77.63797"
                id="rect4136-6"
                onClick={() => 3 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={3 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 3 === activeNode && this.props.onToggleAudio()}
                        transform="translate(267.16467,184.27083) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={3 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 3 === activeNode && this.props.onToggleAudio()}
                        fill={3 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(267.16467,184.27083) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }

            <rect
                ry="16.181023"
                y="280.50534"
                x="30.588684"
                height="53.652874"
                width="77.63797"
                id="rect4136-7"
                onClick={() => 4 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={4 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 4 === activeNode && this.props.onToggleAudio()}
                        transform="translate(30.588684,280.50534) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={4 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 4 === activeNode && this.props.onToggleAudio()}
                        fill={4 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(30.588684,280.50534) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }

            <rect
                ry="16.181023"
                y="280.50534"
                x="127.2699"
                height="53.652874"
                width="77.63797"
                id="rect4136-5"
                onClick={() => 5 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={5 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 5 === activeNode && this.props.onToggleAudio()}
                        transform="translate(127.2699,280.50534) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={5 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 5 === activeNode && this.props.onToggleAudio()}
                        fill={5 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(127.2699,280.50534) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }

            <rect
                ry="16.181023"
                y="280.50534"
                x="222.4863"
                height="53.652874"
                width="77.63797"
                id="rect4136-35"
                onClick={() => 6 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={6 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 6 === activeNode && this.props.onToggleAudio()}
                        transform="translate(222.4863,280.50534) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={6 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 6 === activeNode && this.props.onToggleAudio()}
                        fill={6 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(222.4863,280.50534) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }

            <rect
                ry="16.181023"
                y="280.50534"
                x="316.97021"
                height="53.652874"
                width="77.63797"
                id="rect4136-62"
                onClick={() => 7 === activeNode && this.props.onToggleAudio()}
                stroke="white" strokeWidth="2" fill={7 === activeNode ? 'url(#grad1)' : BACKGROUND_DARK2} />

            {
                this.props.isPaused ? (
                    <path
                        onClick={() => 7 === activeNode && this.props.onToggleAudio()}
                        transform="translate(316.97021,280.50534) scale(4) translate(-17.5, -6.4)"
                        d="m 31,13 c 0,1.385641 -4.8,4.156922 -6,3.464102 C 23.8,15.771281 23.8,10.228719 25,9.5358984 26.2,8.8430781 31,11.614359 31,13 Z"
                        id="path2054"
                        fill={7 === activeNode ? 'white' : BACKGROUND_DARK2}
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}} />
                ) : (
                    <g
                        onClick={() => 7 === activeNode && this.props.onToggleAudio()}
                        fill={7 === activeNode ? 'white' : BACKGROUND_DARK2}
                        transform="translate(316.97021,280.50534) scale(1,0.8) translate(1, 6.5)"
                        style={{opacity: 1, fillOpacity: 1, strokeWidth: 4, strokeOpacity: 1}}
                        id="g2032">
                        <rect
                            id="rect1976"
                            width="8.3767042"
                            height="36.354897"
                            x="24.62751"
                            y="8"
                            ry="2.0104089" />
                        <rect
                            ry="2.0104089"
                            y="8"
                            x="42.218586"
                            height="36.354897"
                            width="8.3767042"
                            id="rect1976-3" />
                    </g>
                        
                )
            }
                
                {
                    /*
                    <rect
                        ry="5"
                        y="250"
                        x="265.5"
                        height="15"
                        width="30"
                        id="rect4136-642536"
                        stroke="white" strokeWidth="2" fill={8 === activeNode ? 'url(#grad1)' : 'black'} />
                    */
                }




{/*<svg x="310" y="243" height={30} width={30} viewBox="0 0 60 60">*/}
<svg x="345" y="243" height={20} width={20} viewBox="0 0 60 60">
            <rect
            style={{
                strokeLinejoin: "round",
                fillRule: "evenodd",
                stroke: "white",
                strokeWidth: 3.125,
                fill: BACKGROUND_DARK2,
            }}
            rx={4.612}
            transform="rotate(-15)"
            height={26.995}
            width={26.995}
            y={30.787}
            x={-5.783}
            />
            <path
            style={{
                fillRule: "evenodd",
                stroke: "white",
                strokeWidth: 1.6055,
                fill: "white",
            }}
            d="M30.411 35.379a1.081 1.081 0 1 0-2.164 0 1.082 1.082 0 1 0 2.164 0h-1.082z"
            transform="translate(-37.925 -27.587) scale(1.9464)"
            />
            <rect
            style={{
                strokeLinejoin: "round",
                fillRule: "evenodd",
                stroke: "white",
                strokeWidth: 3.125,
                fill: BACKGROUND_DARK2,
            }}
            rx={4.612}
            transform="rotate(15)"
            height={26.995}
            width={26.995}
            y={-4.66}
            x={31.599}
            />
            <path
            style={{
                fillRule: "evenodd",
                stroke: "white",
                strokeWidth: 1.6055,
                fill: "white",
            }}
            d="M30.411 35.379a1.081 1.081 0 1 0-2.164 0 1.082 1.082 0 1 0 2.164 0h-1.082z"
            transform="translate(-21.758 -44.691) scale(1.9464)"
            />
            <path
            style={{
                fillRule: "evenodd",
                stroke: "white",
                strokeWidth: 1.6055,
                fill: "white",
            }}
            d="M30.411 35.379a1.081 1.081 0 1 0-2.164 0 1.082 1.082 0 1 0 2.164 0h-1.082z"
            transform="translate(-9.622 -52.369) scale(1.9464)"
            />
        </svg>
        </svg>
        </div>
      )
    }
  }
  
  
  export default Diagram;


// WEBPACK FOOTER //
// ./src/components/InteractiveExample/Diagram.js